import { Box, Typography } from "@mui/material"
import type { ReactNode } from "react"

export interface ILabelValueProps {
    /** Rótulo (em cima, azul, 16px). */
    label: ReactNode
    /** Valor (embaixo, branco, 20px). Quando ausente, renderiza `children`. */
    value?: ReactNode
    /** Conteúdo customizado abaixo do rótulo (ex.: chip), quando `value` não se aplica. */
    children?: ReactNode
    align?: "left" | "center" | "right"
    mt?: number | string
    /** Sobrescreve a cor do valor (ex.: estados de sucesso/erro). */
    valueColor?: string
}

/**
 * Par padrão "rótulo + valor" usado em todos os cards (seções, painéis e modais):
 * rótulo em azul da marca (16px) em cima e valor em branco maior (20px) embaixo.
 */
const LabelValue = ({ label, value, children, align = "left", mt, valueColor }: ILabelValueProps) => (
    <Box sx={{ mt, textAlign: align, minWidth: 0 }}>
        <Typography
            component="div"
            sx={{ fontSize: 16, lineHeight: 1.3, fontWeight: 600, color: "primary.main" }}
        >
            {label}
        </Typography>
        {value !== undefined && value !== null ? (
            <Typography
                component="div"
                sx={{
                    fontSize: 20,
                    lineHeight: 1.3,
                    fontWeight: 700,
                    color: valueColor ?? "neutral.lighter",
                    mt: 0.25,
                }}
            >
                {value}
            </Typography>
        ) : (
            children
        )}
    </Box>
)

export { LabelValue }
